/** @type import('highlight.js') */
var hljs = require('highlight.js/lib/core');

var hljsDefineSolidity = require('highlightjs-solidity');

hljsDefineSolidity(hljs);
module.exports = hljs;